import styled, { css, keyframes } from "styled-components";
import UiButton from "../../../../../components/Button";
import ButtonUi from "../../../../../components/Button";
import LinkUi from "../../../../../components/Link";
import { Link as LinkRrd } from "react-router-dom";
import Icon from "../../../../../components/Icon";
import Markdown from "markdown-to-jsx";

export const Card = styled("div")`
  overflow: hidden;
  border-radius: 16px;
  background-color: white;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  box-shadow: 0px 6px 12px 0px rgba(0, 0, 0, 0.12);
  transition: box-shadow 0.3s ease-in-out;
   height: 338px;

  &:hover {
    box-shadow: 0px 3px 5px 3px rgba(0,0,0,.1);
  }
`;

export const Top = styled("div")`
  position: absolute;
  z-index: 10;
  display: flex;
  align-elements: center;
  justify-content: flex-end;
  width: 100%;
  padding: 18px;
`;

export const Actions = styled("div")`
  display: flex;
  width: 100%;
  align-elements: center;
  justify-content: flex-end;
  gap: 4px;
`;

export const Circle = styled("div")`
  position: relative;
  width: 28px;
  height: 28px;
  background: white;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease-in-out;
  overflow: hidden;

  &:hover {
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  }
`;

const cleanCta = css`
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;
  pointer-events: auto;
  width: 21px;
  height: 21px;
  border-radius: 100%;
  min-width: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    box-shadow: none;
  }
`;

export const Link = styled(LinkUi)`
  ${cleanCta}
`;

export const Button = styled(ButtonUi)`
  ${cleanCta}
`;

export const Title = styled("h3")`
  font-weight: 600;
  font-size: 18px;
  color: black;
  margin: 0px;
  line-height: 22px;
  min-height: 44px;

  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal;

  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
  width: 100%;

  @media(min-width: 768px){
    font-size: 18px;
    min-height: 44px;
  }
`;

export const Date = styled("span")`
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: black;
  margin-top: 4px;
`;

export const GoToPreview = styled(LinkRrd) <{ coverPicHeight?}>`
  width: 100%;
  height: 100%;
  padding: ${({ coverPicHeight }) => !!coverPicHeight ? `${coverPicHeight + 22}px 18px 22px` : "124px 18px 22px"};
  text-decoration: none;
  color: inherit;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`;

export const Background = styled("div") <{ backgroundImage?, height?}>`
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, 0%);
  width: 100%;
  height: ${({ height }) => !!height ? `${height}px` : "125px"};
  transition: all 0.3s ease-in-out 0s;
  overflow: hidden;

  ${({ backgroundImage }) =>
    !!backgroundImage
      ? "background-image:url('" +
      backgroundImage +
      "'); background-size: cover; background-repeat: no-repeat; background-position: center;"
      : ""}

  &:after {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    background: linear-gradient(rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.2) 44.79%, rgba(0, 0, 0, 0.4) 100%);
  }
`;

export const Image = styled("div") <{ backgroundImage?, block?}>`
  width: 100%;
  height: 100%;
  transition: all 0.3s ease-in-out 0s;

  ${({ backgroundImage }) =>
    !!backgroundImage
      ? "background-image:url('" +
      backgroundImage +
      "'); background-size: cover; background-repeat: no-repeat; background-position: center;"
      : ""}

  ${({ block }) => !!block ? "filter: blur(40px);" : ""}
`;

export const Statistics = styled("div")`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 22px;
`;

export const StatItem = styled("div")`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  text-align: left;
  width: 100%;
`;

export const StatNumber = styled("div")`
  font-weight: 600;
  line-height: normal;
  font-size: 28px;
  color: ${({ theme }) => theme.colors.Primary};
`;

export const StatLabel = styled("div")`
  font-size: 14px;
  color: #2D3436;
`;

export const ActionButtons = styled("div")`
  position: absolute;
  left: 18px;
  right: 18px;
  bottom: 22px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

export const GoToLeadsList = styled(LinkUi)`
  padding: 0px 10px;
  min-width: 0px;
  width: 100%;
  gap: 4px;
  // display: flex;
  // align-items: center;
  // justify-content: flex-start;

  // &:hover {
  //   background-color: #7C3AED;
  //   text-decoration: none;
  //   color: white;
  // }
`;

export const ShareButton = styled(ButtonUi)`
  padding: 0px 10px;
  min-width: 0px;
  width: 100%;
  gap: 4px;
  // display: flex;
  // align-items: center;
  // justify-content: flex-start;

  // &:hover {
  //   background-color: #F9FAFB;
  //   border-color: #9CA3AF;
  // }
`;

export const BlockedLabel = styled.div`
  position: absolute;
  bottom: 10px;
  left: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  font-size: 14px;
  font-weight: 500;
  color: white;
  border-radius: 30px;
  padding: 8px 12px;
  background-color: black;

  @media(min-width: 768px){
    font-size: 14px;
  }
`

export const Separator = styled('div')`
  height: 100%;
  width: 1px;
  background-color: #E0E0E0;
`